import { decodeGoogleAddressComponents } from "dora-contracts";
const LOOKUP_ATTEMPTS = 3;
const RETRY_DELAY_MS = 200;
const TRANSIENT_STATUSES = [
    "INTERNAL",
    "UNKNOWN_ERROR",
    "OVER_QUERY_LIMIT",
    "DEADLINE_EXCEEDED",
];
export class PlaceDetailsError extends Error {
    status;
    transient;
    data;
    constructor(message, status, transient, data) {
        super(message);
        this.status = status;
        this.transient = transient;
        this.data = data;
        this.name = "PlaceDetailsError";
    }
}
const fetchPlaceDetails = async (url) => {
    const response = await fetch(url).catch((err) => {
        throw new PlaceDetailsError(`Network error getting place details: ${err?.message ?? err}`, undefined, true);
    });
    if (!response.ok) {
        throw new PlaceDetailsError(`Failed to get place details: HTTP ${response.status}`, undefined, response.status >= 500);
    }
    const data = await response.json();
    if (data.status !== "OK") {
        throw new PlaceDetailsError(`Not-ok response from google place details: ${data.status}`, data.status, TRANSIENT_STATUSES.includes(data.status), data);
    }
    const { country, ...decodedAddress } = decodeGoogleAddressComponents(data.result.address_components);
    const { lat, lng } = data.result.geometry.location;
    return {
        placeName: data.result.name,
        ...decodedAddress,
        countryCode: country,
        coords: { lat, lon: lng },
    };
};
const getPlaceDetails = async (placeId, sessionId, apiKey, urlPrefix) => {
    const fields = ["name", "address_components", "geometry"];
    const url = `${urlPrefix ?? ""}/maps/api/place/details/json?place_id=${placeId}&sessiontoken=${sessionId}&key=${apiKey}&fields=${fields.join(",")}`;
    for (let attempt = 1;; attempt++) {
        try {
            return await fetchPlaceDetails(url);
        }
        catch (err) {
            const retryable = err instanceof PlaceDetailsError && err.transient;
            if (!retryable || attempt >= LOOKUP_ATTEMPTS) {
                throw err;
            }
            await new Promise((r) => setTimeout(r, RETRY_DELAY_MS * attempt));
        }
    }
};
export default getPlaceDetails;
//# sourceMappingURL=get-place-details.js.map